import React from "react";
import injectSheet from "react-jss";
import NumberFormat from "react-number-format";
import { roundToNearest } from "../../budget/selectors";

const OfferBudget = (props) => {
	const { classes, budgetSelection, houseTypeSelection, plotSelection } = props;

	return (
		<div className={`${classes.container}`}>
			<div className={`${classes.element}`}>
				<h4>Bauland</h4>
				<p>{plotSelection ? "Ich suche Bauland" : "Ich habe Bauland"}</p>
			</div>

			<div className={`${classes.element}`}>
				<h4>
					Budget (
					{
						<NumberFormat
							displayType="text"
							value={budgetSelection.total}
							thousandSeparator="'"
							suffix={` ${budgetSelection.currency}`}
						/>
					}
					)
				</h4>
				<p className={`${classes.budgetElement}`}>
					<span>Bauland</span>
					{(!plotSelection && (
						<span className={`${classes.elementCost}`}>vorhanden</span>
					)) || (
						<NumberFormat
							displayType="text"
							value={budgetSelection.plotPrice}
							thousandSeparator="'"
							suffix={` ${budgetSelection.currency}`}
						/>
					)}
				</p>
				<p className={`${classes.budgetElement}`}>
					<span>Nebenkosten</span>
					<NumberFormat
						displayType="text"
						value={roundToNearest(budgetSelection.totalReached * 0.12, 3)}
						thousandSeparator="'"
						suffix={` ${budgetSelection.currency}`}
					/>
				</p>
				<p className={`${classes.budgetElement}`}>
					<span>Haus inkl. Optionen</span>
					<NumberFormat
						displayType="text"
						value={
							budgetSelection.totalReached -
							roundToNearest(budgetSelection.totalReached * 0.12, 3) -
							budgetSelection.plotPrice
						}
						thousandSeparator="'"
						suffix={` ${budgetSelection.currency}`}
					/>
				</p>
			</div>

			<div className={`${classes.element}`}>
				<h4>Haustyp</h4>
				<p>
					{houseTypeSelection.houseType
						? houseTypeSelection.houseType.title
						: null}
				</p>
			</div>
		</div>
	);
};

const styles = (theme) => ({
	container: {
		padding: `${theme.sizes.gutter / 2}px 0`,
		display: "flex",
		flexWrap: "wrap",
		height: "100%",
		borderBottom: `2px solid ${theme.colors.secondary_3a}`,
	},
	element: {
		padding: `${theme.sizes.gutter / 2}px`,
		width: "100%",
		[theme.media.medium]: {
			width: `${100 / 2}%`,
			"&:nth-of-type(2)": {
				borderLeft: `2px solid ${theme.colors.secondary_3a}`,
			},
			"&:nth-of-type(3)": {
				width: "100%",
			},
		},
		[theme.media.large]: {
			width: `${100 / 3}%`,
			"&:nth-of-type(3)": {
				width: `${100 / 3}%`,
				borderLeft: `2px solid ${theme.colors.secondary_3a}`,
			},
		},
		"& h4": {
			marginTop: 0,
		},
	},
	budgetElement: {
		display: "flex",
		justifyContent: "space-between",
		margin: `${theme.sizes.gutter / 4}px 0`,
		"&:last-of-type": {
			marginBottom: `${theme.sizes.gutter / 2}px 0`,
		},
	},
});

export default injectSheet(styles)(OfferBudget);



// WEBPACK FOOTER //
// ./src/modules/offer/components/offerBudget.jsx